import React from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  styled,
} from "@mui/material";

// Styled components
const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(2),
}));

const TermsAndConditions = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Terms and Conditions
      </Typography>

      <StyledPaper elevation={0}>
        <Section>
          <SectionTitle variant="h6">A. ACCEPTANCE OF TERMS</SectionTitle>
          <Typography variant="body1" gutterBottom>
            By using the Platform, you hereby accept these Terms (including the
            linked information herein) and represent that you agree to comply
            with these Terms. This Content Provider Agreement is deemed
            effective upon your use of the Platform which signifies your
            acceptance of these Terms. If you do not agree to be bound by this
            Content Provider Agreement, please do not access, register with, or
            use the Platform.
          </Typography>
        </Section>

        <Divider sx={{ my: 3 }} />

        <Section>
          <SectionTitle variant="h6">
            B. AMENDMENT; NOTICE OF CHANGES
          </SectionTitle>
          <Typography variant="body1" gutterBottom>
            The Platform will change over time and the terms of this Agreement
            will need to change over time as well. Subject to the provisions of
            this Agreement, we reserve the right to change the terms and
            conditions in this Agreement at any time in our sole discretion.
          </Typography>
        </Section>

        <Divider sx={{ my: 3 }} />

        <Section>
          <SectionTitle variant="h6">C. REGISTRATION</SectionTitle>
          <Typography variant="body1" gutterBottom>
            To access the Platform, you must create an account by providing
            accurate and complete registration information, including but not
            limited to a valid email address, username, and password. You are
            responsible for maintaining the confidentiality of your account
            information and for all activities that occur under your account.
          </Typography>
        </Section>

        <Divider sx={{ my: 3 }} />

        <Section>
          <SectionTitle variant="h6">D. TERM</SectionTitle>
          <Typography variant="body1" gutterBottom>
            This Agreement commences upon your acceptance of it and continues in
            perpetuity until terminated as set forth in Section L of this
            Agreement.
          </Typography>
        </Section>

        <Divider sx={{ my: 3 }} />

        <Section>
          <SectionTitle variant="h6">E. CONTENT OWNERSHIP RIGHTS</SectionTitle>
          <Typography variant="body1" gutterBottom>
            You retain ownership of any content you upload to the Platform,
            including but not limited to videos, audio files, articles, and
            games (the "Content") and their Promotional Materials. By uploading
            Content to the Platform, you grant DreamStream a non-exclusive,
            worldwide, royalty-free license to use, distribute, modify, display,
            and perform the Content in connection with the operation of
            DreamStream services.
          </Typography>
        </Section>

        <Divider sx={{ my: 3 }} />

        <Section>
          <SectionTitle variant="h6">F. CONTENT GUIDELINES</SectionTitle>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Content Providers must adhere to the following guidelines:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="Content must not contain illegal, offensive, or defamatory material." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Content must not infringe on the intellectual property rights of others." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Content must comply with all applicable laws and regulations." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Content must not contain viruses, malware, or any other harmful software." />
            </ListItem>
          </List>

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mt: 3, mb: 2 }}
          >
            The following types of Content are prohibited:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="Pornographic or obscene material." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Hate speech, threats, or any material that promotes violence or discrimination." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Content that violates any applicable laws or regulations." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Content that exploits or harms minors in any way." />
            </ListItem>
          </List>
        </Section>

        <Divider sx={{ my: 3 }} />

        <Section>
          <SectionTitle variant="h6">Technical Requirements</SectionTitle>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Video Format Requirements:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="16:9 aspect ratio" />
            </ListItem>
            <ListItem>
              <ListItemText primary="30 frames per second" />
            </ListItem>
            <ListItem>
              <ListItemText primary="MP4/H.264 (1280 x 720)" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Minimum 720 pixels" />
            </ListItem>
            <ListItem>
              <ListItemText primary="4 Audio Channels: Dialogue, Music, Foley (Ambiance), Mix" />
            </ListItem>
          </List>
        </Section>
      </StyledPaper>
    </Container>
  );
};

export default TermsAndConditions;
